module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "items"
  }, [(!_vm.onMobile) ? _c('div', [_vm._l((_vm.items), function(item) {
    return [_c('div', {
      key: item.id,
      staticClass: "item"
    }, [_c('div', {
      staticClass: "item__header"
    }, [_c('router-link', {
      attrs: {
        "to": ("/" + (item.user.slug))
      }
    }, [_c('div', {
      staticClass: "item__image",
      style: (("background-image: url(" + (item.user.avatar.url) + ")"))
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "item__content"
    }, [_c('div', {
      staticClass: "item__title"
    }, [_c('router-link', {
      attrs: {
        "to": ("/" + (item.user.slug))
      }
    }, [_vm._v("\n              " + _vm._s(_vm._f("capitalize")(item.user.username)) + "\n            ")]), _vm._v(" "), (!_vm.hideDatedString) ? _c('span', [_vm._v(_vm._s(_vm.toLocalTimeString(item.created_at)))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "item__description",
      domProps: {
        "innerHTML": _vm._s(item.body)
      }
    })]), _vm._v(" "), (_vm.showShortAge) ? _c('div', {
      staticClass: "item__age"
    }, [_vm._v(_vm._s(_vm._f("formatDateFromNowShort")(item.created_at)))]) : _vm._e()])]
  })], 2) : _c('div', [_vm._l((_vm.items), function(item) {
    return [_c('item-swipe', {
      key: item.id
    }, [_c('template', {
      slot: "leftComponent"
    }, [_c('div', {
      key: item.id,
      staticClass: "item"
    }, [_c('div', {
      staticClass: "item__header"
    }, [_c('user-tag', {
      attrs: {
        "user": item.user,
        "width": "42",
        "height": "42",
        "hideName": "",
        "hideTick": "",
        "showAvatar": ""
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "item__content"
    }, [_c('div', {
      staticClass: "item__title"
    }, [_c('div', {
      staticClass: "created_by"
    }, [_vm._v("\n                    " + _vm._s(_vm._f("capitalize")(item.user.username)) + "\n                  ")]), _vm._v(" "), (!_vm.hideDatedString) ? _c('span', {
      staticClass: "created_at"
    }, [_vm._v(_vm._s(_vm.toLocalTimeString(item.created_at)))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "item__description",
      domProps: {
        "innerHTML": _vm._s(item.body)
      }
    })]), _vm._v(" "), (_vm.showShortAge) ? _c('div', {
      staticClass: "item__age"
    }, [_vm._v(_vm._s(_vm._f("formatDateFromNowShort")(item.created_at)))]) : _vm._e()])]), _vm._v(" "), _c('template', {
      slot: "rightComponent"
    }, [_c('v-btn', {
      staticStyle: {
        "background": "#FF6565"
      },
      attrs: {
        "depressed": ""
      },
      on: {
        "click": function($event) {
          _vm.deleteComment()
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "white"
      }
    }, [_vm._v("delete")])], 1)], 1)], 2)]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-551a8f77","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat.vue
// module id = 1727
// module chunks = 180